var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h2", { staticStyle: { "margin-bottom": "32px" } }, [
        _vm._v("Welcome back, " + _vm._s(_vm.contactPersonName))
      ]),
      _c("div", { staticClass: "col-xs-12 col-sm-4" }, [
        _c(
          "a",
          {
            attrs: {
              href: "javascript:;",
              "data-toggle": "modal",
              "data-target": "#choose-pickl-type-popup"
            }
          },
          [
            _c("Card", {
              attrs: {
                icon: "Dashboard/create_pickl.png",
                value: "Build Campaign",
                color: "#6B8F5E"
              }
            })
          ],
          1
        )
      ]),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-4" },
        [
          _c(
            "router-link",
            { attrs: { to: "/brand/payment-history?tab=subscription" } },
            [
              _c("Card", {
                attrs: {
                  icon: "Dashboard/brandpayment_icon.png",
                  value: "Credits: " + _vm.dashboardContent.credits,
                  color: "#38b2ac"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-4" },
        [
          _c(
            "router-link",
            { attrs: { to: "/brand/tutorial-videos" } },
            [
              _c("Card", {
                attrs: {
                  icon: "Dashboard/viewhostory_icon.png",
                  value: "Tutorials",
                  color: "#718096"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-sm-4 col-xs-12" },
        [
          _c("h3", { staticClass: "dashboard-section-title" }, [
            _vm._v("Geo-Located Activities")
          ]),
          _c(
            "router-link",
            { attrs: { to: "/brand/pickl-history?status=APPROVED" } },
            [
              _c("Card", {
                attrs: {
                  icon: "Dashboard/newpickls_icon.png",
                  value: "Fresh Alerts",
                  color: "#38a169"
                }
              })
            ],
            1
          ),
          _c(
            "a",
            {
              staticStyle: { cursor: "pointer" },
              attrs: {
                "data-target": "#export-pickl-popup",
                "data-toggle": "modal"
              }
            },
            [
              _c("Card", {
                attrs: {
                  icon: "Dashboard/create_pickl.png",
                  value: "Data Export",
                  color: "#805ad5"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-sm-4 col-xs-12" },
        [
          _c("h3", { staticClass: "dashboard-section-title" }, [
            _vm._v("Go-Anywhere Activities")
          ]),
          _c(
            "router-link",
            { attrs: { to: "/brand/non-geo-pickl-history?status=APPROVED" } },
            [
              _c("Card", {
                attrs: {
                  icon: "Dashboard/newpickls_icon.png",
                  value: "Fresh Alerts",
                  color: "#38a169"
                }
              })
            ],
            1
          ),
          _c(
            "router-link",
            { attrs: { to: "/brand/non-geo-pickl-history?status=APPROVED" } },
            [
              _c("Card", {
                attrs: {
                  icon: "Dashboard/create_pickl.png",
                  value: "Data Export",
                  color: "#805ad5"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-sm-4 col-xs-12" },
        [
          _c("h3", { staticClass: "dashboard-section-title" }, [
            _vm._v("Data Visuals")
          ]),
          _vm.$store.state.userData.brandId == 240
            ? _c(
                "router-link",
                { attrs: { to: "/brand/insight-custom" } },
                [
                  _c("Card", {
                    attrs: {
                      icon: "Dashboard/brandpayment_icon.png",
                      value: "Campaign Summary",
                      color: "#dd6b20"
                    }
                  })
                ],
                1
              )
            : _c(
                "router-link",
                { attrs: { to: "/brand/campaigns" } },
                [
                  _c("Card", {
                    attrs: {
                      icon: "Dashboard/brandpayment_icon.png",
                      value: "Campaigns",
                      color: "#dd6b20"
                    }
                  })
                ],
                1
              ),
          _c(
            "router-link",
            { attrs: { to: "/brand/insights" } },
            [
              _c("Card", {
                attrs: {
                  icon: "Dashboard/viewhostory_icon.png",
                  value: " Insights ",
                  color: "#3182ce"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c("choose-pickl-type-popup", {
        attrs: {
          brandId: _vm.$store.state.userData.brandId,
          popupId: "choose-pickl-type-popup"
        }
      }),
      _c("ExportPickl", {
        attrs: { popupId: "export-pickl-popup", brandId: _vm.brandId }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }